/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { FeeRange } from "./FeeRange";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";
import { DateFromString } from "@pagopa/ts-commons/lib/dates";

export enum StatusEnum {
  "ENABLED" = "ENABLED",

  "DISABLED" = "DISABLED",

  "MAINTENANCE" = "MAINTENANCE"
}

export enum MethodManagementEnum {
  "ONBOARDABLE" = "ONBOARDABLE",

  "ONBOARDABLE_ONLY" = "ONBOARDABLE_ONLY",

  "NOT_ONBOARDABLE" = "NOT_ONBOARDABLE",

  "REDIRECT" = "REDIRECT"
}

export enum DisabledReasonEnum {
  "AMOUNT_OUT_OF_BOUND" = "AMOUNT_OUT_OF_BOUND",

  "MAINTENANCE_IN_PROGRESS" = "MAINTENANCE_IN_PROGRESS",

  "METHOD_DISABLED" = "METHOD_DISABLED",

  "NOT_YET_VALID" = "NOT_YET_VALID",

  "TARGET_PREVIEW" = "TARGET_PREVIEW",

  "NO_BUNDLE_AVAILABLE" = "NO_BUNDLE_AVAILABLE"
}

// additional attributes

export const PaymentMethodResponseName = t.record(
  t.string,

  t.string,

  "PaymentMethodResponseName"
);

export type PaymentMethodResponseName = t.TypeOf<
  typeof PaymentMethodResponseName
>;

// additional attributes

export const PaymentMethodResponseDescription = t.record(
  t.string,

  t.string,

  "PaymentMethodResponseDescription"
);

export type PaymentMethodResponseDescription = t.TypeOf<
  typeof PaymentMethodResponseDescription
>;

// additional attributes

export const PaymentMethodResponsePaymentMethodsBrandAssets = t.record(
  t.string,

  t.string,

  "PaymentMethodResponsePaymentMethodsBrandAssets"
);

export type PaymentMethodResponsePaymentMethodsBrandAssets = t.TypeOf<
  typeof PaymentMethodResponsePaymentMethodsBrandAssets
>;

// additional attributes

export const PaymentMethodResponseMetadata = t.record(
  t.string,

  t.string,

  "PaymentMethodResponseMetadata"
);

export type PaymentMethodResponseMetadata = t.TypeOf<
  typeof PaymentMethodResponseMetadata
>;

// required attributes
const PaymentMethodResponseR = t.interface({
  id: t.string,

  name: PaymentMethodResponseName,

  description: PaymentMethodResponseDescription,

  status: enumType<StatusEnum>(StatusEnum, "status"),

  validityDateFrom: DateFromString,

  paymentTypeCode: t.string,

  paymentMethodTypes: t.readonlyArray(t.string, "array of string"),

  paymentMethodAsset: t.string,

  methodManagement: enumType<MethodManagementEnum>(
    MethodManagementEnum,
    "methodManagement"
  )
});

// optional attributes
const PaymentMethodResponseO = t.partial({
  feeRange: FeeRange,

  disabledReason: enumType<DisabledReasonEnum>(
    DisabledReasonEnum,
    "disabledReason"
  ),

  paymentMethodsBrandAssets: PaymentMethodResponsePaymentMethodsBrandAssets,

  metadata: PaymentMethodResponseMetadata
});

export const PaymentMethodResponse = t.intersection(
  [PaymentMethodResponseR, PaymentMethodResponseO],
  "PaymentMethodResponse"
);

export type PaymentMethodResponse = t.TypeOf<typeof PaymentMethodResponse>;
